import { Component, OnChanges, Type } from "@angular/core";
import { FormControl } from "@angular/forms";
import { DefaultMarkerDisplayComponent } from "src/app/components/global/prefixes/templates/template-map/default-marker-display/default-marker-display.component";
import { v4 as uuid } from "uuid";
import { MarkerData, TemplateMapComponent } from "../../../../global/prefixes/templates/template-map/template-map.component";
import { FormCategory } from "../../../form/form-category";
import { FormField } from "../../../form/form-field";
import { FormFields } from "../../../form/form.definition";
import { TableField } from "../../table-field";
import { TableGroup } from "../../table-group";
import { TableHeader, TableHeaderMap } from "../../table-header";
import { TableViewComponent } from "../table-view.component";
import { TableMapViewMarkerDisplayComponent } from "./table-map-view-marker-display/table-map-view-marker-display.component";

@Component({
  selector: "app-table-map-view",
  imports: [TemplateMapComponent],
  templateUrl: "./table-map-view.component.html",
  styleUrl: "./table-map-view.component.less",
})
export class TableMapViewComponent extends TableViewComponent implements OnChanges {
  public control: FormControl<MarkerData<{ fields: FormFields }>[] | null>;

  public markerDisplayComponent: Type<DefaultMarkerDisplayComponent>;

  public constructor() {
    super();
    this.control = new FormControl<MarkerData<{ fields: FormFields }>[] | null>(null);
    this.markerDisplayComponent = TableMapViewMarkerDisplayComponent;
  }

  public ngOnChanges(): void {
    const markers: MarkerData<{ fields: FormFields }>[] = [];

    const parseGroup = (g: TableGroup): void => {
      for (const row of g.rows) {
        const data: MarkerData<{ fields: FormFields }> = { id: uuid(), location: new google.maps.LatLng(0, 0), data: { fields: new Map() } };
        const category = new FormCategory("Algemeen");
        const fields: Map<number, FormField> = new Map();
        for (let index = 0; index < row.fields.length; index++) {
          const field = row.fields.at(index);
          const header = this.headers.at(index);
          if (!field || !header || header.options.map === TableHeaderMap.NONE) {
            continue;
          }
          if (header.options.map === TableHeaderMap.PIN) {
            const location = field.value.value as { lat: number; lon: number } | null;
            if (!location) continue;
            data.location = new google.maps.LatLng(location.lat, location.lon);
          }
          if (header.options.map === TableHeaderMap.POPUP) {
            const formField = new FormField(header.name, field?.value.value, header.pfx, header.label);
            formField.readonly = true;
            formField.extras = this.getExtras(header, field);
            fields.set(fields.size, formField);
          }
        }
        category.setFields(fields);
        data.data?.fields.set(0, category);
        markers.push(data);
      }
      for (const group of g.groups) {
        parseGroup(group);
      }
    };

    parseGroup(this.root);

    this.control.setValue(markers);
  }

  public override sortColumns(): void {
    if (this.options.layout) {
      const { map_columns } = this.options.layout;
      this.headers.sort((a, b) => map_columns.popup.indexOf(a.name) - map_columns.popup.indexOf(b.name));
      for (const row of this.getAllRows()) {
        row.fields.sort((a, b) => map_columns.popup.indexOf(a.name) - map_columns.popup.indexOf(b.name));
      }
    }
  }

  private getExtras(header: TableHeader, field: TableField): Record<string, unknown> | null {
    switch (header.pfx) {
      case "lni":
        return { ...field.extras, size: 100 };
      default:
        return field.extras;
    }
  }
}
